"use strict";
/**
 *
 * The key descriptions are copy-pasta'd from Nathan Friend's [ts-key-enum](https://www.npmjs.com/package/ts-key-enum).
 * Below is the MIT license notice, also copy-pasta'd from ts-key-enum.
 *
 * MIT License
 *
 * Copyright (c) 2018 Nathan Friend
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Key = void 0;
/**
 * Namespace of standard non-printable `KeyboardEvent.Key` values.
 */
var Key;
(function (Key) {
    Key.Unidentified = "Unidentified";
    Key.Alt = "Alt";
    Key.AltGraph = "AltGraph";
    Key.CapsLock = "CapsLock";
    Key.Control = "Control";
    Key.Fn = "Fn";
    Key.FnLock = "FnLock";
    Key.Hyper = "Hyper";
    Key.Meta = "Meta";
    Key.NumLock = "NumLock";
    Key.ScrollLock = "ScrollLock";
    Key.Shift = "Shift";
    Key.Super = "Super";
    Key.Symbol = "Symbol";
    Key.SymbolLock = "SymbolLock";
    Key.Enter = "Enter";
    Key.Tab = "Tab";
    Key.ArrowDown = "ArrowDown";
    Key.ArrowLeft = "ArrowLeft";
    Key.ArrowRight = "ArrowRight";
    Key.ArrowUp = "ArrowUp";
    Key.End = "End";
    Key.Home = "Home";
    Key.PageDown = "PageDown";
    Key.PageUp = "PageUp";
    Key.Backspace = "Backspace";
    Key.Clear = "Clear";
    Key.Copy = "Copy";
    Key.CrSel = "CrSel";
    Key.Cut = "Cut";
    Key.Delete = "Delete";
    Key.EraseEof = "EraseEof";
    Key.ExSel = "ExSel";
    Key.Insert = "Insert";
    Key.Paste = "Paste";
    Key.Redo = "Redo";
    Key.Undo = "Undo";
    Key.Accept = "Accept";
    Key.Again = "Again";
    Key.Attn = "Attn";
    Key.Cancel = "Cancel";
    Key.ContextMenu = "ContextMenu";
    Key.Escape = "Escape";
    Key.Execute = "Execute";
    Key.Find = "Find";
    Key.Finish = "Finish";
    Key.Help = "Help";
    Key.Pause = "Pause";
    Key.Play = "Play";
    Key.Props = "Props";
    Key.Select = "Select";
    Key.ZoomIn = "ZoomIn";
    Key.ZoomOut = "ZoomOut";
    Key.BrightnessDown = "BrightnessDown";
    Key.BrightnessUp = "BrightnessUp";
    Key.Eject = "Eject";
    Key.LogOff = "LogOff";
    Key.Power = "Power";
    Key.PowerOff = "PowerOff";
    Key.PrintScreen = "PrintScreen";
    Key.Hibernate = "Hibernate";
    Key.Standby = "Standby";
    Key.WakeUp = "WakeUp";
    Key.AllCandidates = "AllCandidates";
    Key.Alphanumeric = "Alphanumeric";
    Key.CodeInput = "CodeInput";
    Key.Compose = "Compose";
    Key.Convert = "Convert";
    Key.Dead = "Dead";
    Key.FinalMode = "FinalMode";
    Key.GroupFirst = "GroupFirst";
    Key.GroupLast = "GroupLast";
    Key.GroupNext = "GroupNext";
    Key.GroupPrevious = "GroupPrevious";
    Key.ModeChange = "ModeChange";
    Key.NextCandidate = "NextCandidate";
    Key.NonConvert = "NonConvert";
    Key.PreviousCandidate = "PreviousCandidate";
    Key.Process = "Process";
    Key.SingleCandidate = "SingleCandidate";
    Key.HangulMode = "HangulMode";
    Key.HanjaMode = "HanjaMode";
    Key.JunjaMode = "JunjaMode";
    Key.Eisu = "Eisu";
    Key.Hankaku = "Hankaku";
    Key.Hiragana = "Hiragana";
    Key.HiraganaKatakana = "HiraganaKatakana";
    Key.KanaMode = "KanaMode";
    Key.KanjiMode = "KanjiMode";
    Key.Katakana = "Katakana";
    Key.Romaji = "Romaji";
    Key.Zenkaku = "Zenkaku";
    Key.ZenkakuHanaku = "ZenkakuHanaku";
    Key.F1 = "F1";
    Key.F2 = "F2";
    Key.F3 = "F3";
    Key.F4 = "F4";
    Key.F5 = "F5";
    Key.F6 = "F6";
    Key.F7 = "F7";
    Key.F8 = "F8";
    Key.F9 = "F9";
    Key.F10 = "F10";
    Key.F11 = "F11";
    Key.F12 = "F12";
    Key.F13 = "F13";
    Key.F14 = "F14";
    Key.F15 = "F15";
    Key.F16 = "F16";
    Key.F17 = "F17";
    Key.F18 = "F18";
    Key.F19 = "F19";
    Key.F20 = "F20";
    Key.Soft1 = "Soft1";
    Key.Soft2 = "Soft2";
    Key.Soft3 = "Soft3";
    Key.Soft4 = "Soft4";
    Key.AppSwitch = "AppSwitch";
    Key.Call = "Call";
    Key.Camera = "Camera";
    Key.CameraFocus = "CameraFocus";
    Key.EndCall = "EndCall";
    Key.GoBack = "GoBack";
    Key.GoHome = "GoHome";
    Key.HeadsetHook = "HeadsetHook";
    Key.LastNumberRedial = "LastNumberRedial";
    Key.Notification = "Notification";
    Key.MannerMode = "MannerMode";
    Key.VoiceDial = "VoiceDial";
    Key.ChannelDown = "ChannelDown";
    Key.ChannelUp = "ChannelUp";
    Key.MediaFastForward = "MediaFastForward";
    Key.MediaPause = "MediaPause";
    Key.MediaPlay = "MediaPlay";
    Key.MediaPlayPause = "MediaPlayPause";
    Key.MediaRecord = "MediaRecord";
    Key.MediaRewind = "MediaRewind";
    Key.MediaStop = "MediaStop";
    Key.MediaTrackNext = "MediaTrackNext";
    Key.MediaTrackPrevious = "MediaTrackPrevious";
    Key.AudioBalanceLeft = "AudioBalanceLeft";
    Key.AudioBalanceRight = "AudioBalanceRight";
    Key.AudioBassDown = "AudioBassDown";
    Key.AudioBassBoostDown = "AudioBassBoostDown";
    Key.AudioBassBoostToggle = "AudioBassBoostToggle";
    Key.AudioBassBoostUp = "AudioBassBoostUp";
    Key.AudioBassUp = "AudioBassUp";
    Key.AudioFaderFront = "AudioFaderFront";
    Key.AudioFaderRear = "AudioFaderRear";
    Key.AudioSurroundModeNext = "AudioSurroundModeNext";
    Key.AudioTrebleDown = "AudioTrebleDown";
    Key.AudioTrebleUp = "AudioTrebleUp";
    Key.AudioVolumeDown = "AudioVolumeDown";
    Key.AudioVolumeMute = "AudioVolumeMute";
    Key.AudioVolumeUp = "AudioVolumeUp";
    Key.MicrophoneToggle = "MicrophoneToggle";
    Key.MicrophoneVolumeDown = "MicrophoneVolumeDown";
    Key.MicrophoneVolumeMute = "MicrophoneVolumeMute";
    Key.MicrophoneVolumeUp = "MicrophoneVolumeUp";
    Key.TV = "TV";
    Key.TV3DMode = "TV3DMode";
    Key.TVAntennaCable = "TVAntennaCable";
    Key.TVAudioDescription = "TVAudioDescription";
    Key.TVAudioDescriptionMixDown = "TVAudioDescriptionMixDown";
    Key.TVAudioDescriptionMixUp = "TVAudioDescriptionMixUp";
    Key.TVContentsMenu = "TVContentsMenu";
    Key.TVDataService = "TVDataService";
    Key.TVInput = "TVInput";
    Key.TVInputComponent1 = "TVInputComponent1";
    Key.TVInputComponent2 = "TVInputComponent2";
    Key.TVInputComposite1 = "TVInputComposite1";
    Key.TVInputComposite2 = "TVInputComposite2";
    Key.TVInputHDMI1 = "TVInputHDMI1";
    Key.TVInputHDMI2 = "TVInputHDMI2";
    Key.TVInputHDMI3 = "TVInputHDMI3";
    Key.TVInputHDMI4 = "TVInputHDMI4";
    Key.TVInputVGA1 = "TVInputVGA1";
    Key.TVMediaContext = "TVMediaContext";
    Key.TVNetwork = "TVNetwork";
    Key.TVNumberEntry = "TVNumberEntry";
    Key.TVPower = "TVPower";
    Key.TVRadioService = "TVRadioService";
    Key.TVSatellite = "TVSatellite";
    Key.TVSatelliteBS = "TVSatelliteBS";
    Key.TVSatelliteCS = "TVSatelliteCS";
    Key.TVSatelliteToggle = "TVSatelliteToggle";
    Key.TVTerrestrialAnalog = "TVTerrestrialAnalog";
    Key.TVTerrestrialDigital = "TVTerrestrialDigital";
    Key.TVTimer = "TVTimer";
    Key.AVRInput = "AVRInput";
    Key.AVRPower = "AVRPower";
    Key.ColorF0Red = "ColorF0Red";
    Key.ColorF1Green = "ColorF1Green";
    Key.ColorF2Yellow = "ColorF2Yellow";
    Key.ColorF3Blue = "ColorF3Blue";
    Key.ColorF4Grey = "ColorF4Grey";
    Key.ColorF5Brown = "ColorF5Brown";
    Key.ClosedCaptionToggle = "ClosedCaptionToggle";
    Key.Dimmer = "Dimmer";
    Key.DisplaySwap = "DisplaySwap";
    Key.DVR = "DVR";
    Key.Exit = "Exit";
    Key.FavoriteClear0 = "FavoriteClear0";
    Key.FavoriteClear1 = "FavoriteClear1";
    Key.FavoriteClear2 = "FavoriteClear2";
    Key.FavoriteClear3 = "FavoriteClear3";
    Key.FavoriteRecall0 = "FavoriteRecall0";
    Key.FavoriteRecall1 = "FavoriteRecall1";
    Key.FavoriteRecall2 = "FavoriteRecall2";
    Key.FavoriteRecall3 = "FavoriteRecall3";
    Key.FavoriteStore0 = "FavoriteStore0";
    Key.FavoriteStore1 = "FavoriteStore1";
    Key.FavoriteStore2 = "FavoriteStore2";
    Key.FavoriteStore3 = "FavoriteStore3";
    Key.Guide = "Guide";
    Key.GuideNextDay = "GuideNextDay";
    Key.GuidePreviousDay = "GuidePreviousDay";
    Key.Info = "Info";
    Key.InstantReplay = "InstantReplay";
    Key.Link = "Link";
    Key.ListProgram = "ListProgram";
    Key.LiveContent = "LiveContent";
    Key.Lock = "Lock";
    Key.MediaApps = "MediaApps";
    Key.MediaAudioTrack = "MediaAudioTrack";
    Key.MediaLast = "MediaLast";
    Key.MediaSkipBackward = "MediaSkipBackward";
    Key.MediaSkipForward = "MediaSkipForward";
    Key.MediaStepBackward = "MediaStepBackward";
    Key.MediaStepForward = "MediaStepForward";
    Key.MediaTopMenu = "MediaTopMenu";
    Key.NavigateIn = "NavigateIn";
    Key.NavigateNext = "NavigateNext";
    Key.NavigateOut = "NavigateOut";
    Key.NavigatePrevious = "NavigatePrevious";
    Key.NextFavoriteChannel = "NextFavoriteChannel";
    Key.NextUserProfile = "NextUserProfile";
    Key.OnDemand = "OnDemand";
    Key.Pairing = "Pairing";
    Key.PinPDown = "PinPDown";
    Key.PinPMove = "PinPMove";
    Key.PinPToggle = "PinPToggle";
    Key.PinPUp = "PinPUp";
    Key.PlaySpeedDown = "PlaySpeedDown";
    Key.PlaySpeedReset = "PlaySpeedReset";
    Key.PlaySpeedUp = "PlaySpeedUp";
    Key.RandomToggle = "RandomToggle";
    Key.RcLowBattery = "RcLowBattery";
    Key.RecordSpeedNext = "RecordSpeedNext";
    Key.RfBypass = "RfBypass";
    Key.ScanChannelsToggle = "ScanChannelsToggle";
    Key.ScreenModeNext = "ScreenModeNext";
    Key.Settings = "Settings";
    Key.SplitScreenToggle = "SplitScreenToggle";
    Key.STBInput = "STBInput";
    Key.STBPower = "STBPower";
    Key.Subtitle = "Subtitle";
    Key.Teletext = "Teletext";
    Key.VideoModeNext = "VideoModeNext";
    Key.Wink = "Wink";
    Key.ZoomToggle = "ZoomToggle";
    Key.SpeechCorrectionList = "SpeechCorrectionList";
    Key.SpeechInputToggle = "SpeechInputToggle";
    Key.Close = "Close";
    Key.New = "New";
    Key.Open = "Open";
    Key.Print = "Print";
    Key.Save = "Save";
    Key.SpellCheck = "SpellCheck";
    Key.MailForward = "MailForward";
    Key.MailReply = "MailReply";
    Key.MailSend = "MailSend";
    Key.LaunchCalculator = "LaunchCalculator";
    Key.LaunchCalendar = "LaunchCalendar";
    Key.LaunchContacts = "LaunchContacts";
    Key.LaunchMail = "LaunchMail";
    Key.LaunchMediaPlayer = "LaunchMediaPlayer";
    Key.LaunchMusicPlayer = "LaunchMusicPlayer";
    Key.LaunchMyComputer = "LaunchMyComputer";
    Key.LaunchPhone = "LaunchPhone";
    Key.LaunchScreenSaver = "LaunchScreenSaver";
    Key.LaunchSpreadsheet = "LaunchSpreadsheet";
    Key.LaunchWebBrowser = "LaunchWebBrowser";
    Key.LaunchWebCam = "LaunchWebCam";
    Key.LaunchWordProcessor = "LaunchWordProcessor";
    Key.LaunchApplication1 = "LaunchApplication1";
    Key.LaunchApplication2 = "LaunchApplication2";
    Key.LaunchApplication3 = "LaunchApplication3";
    Key.LaunchApplication4 = "LaunchApplication4";
    Key.LaunchApplication5 = "LaunchApplication5";
    Key.LaunchApplication6 = "LaunchApplication6";
    Key.LaunchApplication7 = "LaunchApplication7";
    Key.LaunchApplication8 = "LaunchApplication8";
    Key.LaunchApplication9 = "LaunchApplication9";
    Key.LaunchApplication10 = "LaunchApplication10";
    Key.LaunchApplication11 = "LaunchApplication11";
    Key.LaunchApplication12 = "LaunchApplication12";
    Key.LaunchApplication13 = "LaunchApplication13";
    Key.LaunchApplication14 = "LaunchApplication14";
    Key.LaunchApplication15 = "LaunchApplication15";
    Key.LaunchApplication16 = "LaunchApplication16";
    Key.BrowserBack = "BrowserBack";
    Key.BrowserFavorites = "BrowserFavorites";
    Key.BrowserForward = "BrowserForward";
    Key.BrowserHome = "BrowserHome";
    Key.BrowserRefresh = "BrowserRefresh";
    Key.BrowserSearch = "BrowserSearch";
    Key.BrowserStop = "BrowserStop";
    Key.Decimal = "Decimal";
    Key.Key11 = "Key11";
    Key.Key12 = "Key12";
    Key.Multiply = "Multiply";
    Key.Add = "Add";
    Key.Divide = "Divide";
    Key.Subtract = "Subtract";
    Key.Separator = "Separator";
})(Key = exports.Key || (exports.Key = {}));
exports.default = Key;
